import checkout from '../../services/routes/checkout/index'

const state = {
    step: 1,
    delivery_address: {},
    billing_address: {},
    shipping: {
        name: '',
        cost: 0
    },
    payment_method: null,
    stripe_payment_method: null,
    payment_data: {},
    token: null,
    token_response: {},
    loyalty: {
        id: 0
    }
};

const getters = {
    token: state => state.token,
    token_response: state => state.token_response,
    step: state => state.step,
    billing_address: state => state.billing_address,
    delivery_address: state => state.delivery_address,
    payment_method: state => state.payment_method,
    stripe_payment_method: state => state.stripe_payment_method,
    payment_data: state => state.payment_data,
    shipping: state => state.shipping,
    shipping_method: state => state.shipping.name,
    shipping_cost: state => state.shipping.cost,
    loyalty: state => state.loyalty
};

const actions = {
    setToken({commit}, token) {
        commit('SET_TOKEN', token);
    },
    setTokenResponse({commit}, response) {
        commit('SET_TOKEN_RESPONSE', response);
    },
    setStripePaymentMethod({commit}, stripePaymentMethod) {
        commit('SET_STRIPE_PAYMENT_METHOD', stripePaymentMethod);
    },
    setShipping({commit}, shipping) {
        commit('SET_SHIPPING', shipping);
    },
    setPaymentMethod({commit}, method) {
        commit('SET_PAYMENT_METHOD', method);
    },
    setDeliveryAddress({commit}, address) {
        commit('SET_DELIVERY_ADDRESS', address);
    },
    setBillingAddress({commit}, address) {
        commit('SET_BILLING_ADDRESS', address);
    },
    setLoyalty({commit}, loyalty) {
        commit('SET_LOYALTY', loyalty);
    }
};

// mutations
const mutations = {
    setStep(state, step) {
        state.step = step;
        localStorage.setItem('step', state.step);
    },
    nextStep(state) {
        checkout.store(state);
        state.step++;
        localStorage.setItem('step', state.step);
    },
    previousStep(state) {
        state.step--;
        localStorage.setItem('step', state.step);
    },
    SET_TOKEN(state, token) {
        state.token = token;
    },
    SET_TOKEN_RESPONSE(state, response) {
        state.token_response = response;
    },
    SET_STRIPE_PAYMENT_METHOD(state, stripePaymentMethod) {
        state.stripe_payment_method = stripePaymentMethod;
    },
    SET_SHIPPING(state, shipping) {
        state.shipping = shipping;
    },
    SET_PAYMENT_METHOD(state, method) {
        state.payment_method = method;
    },
    SET_DELIVERY_ADDRESS(state, address) {
        state.delivery_address = address;
    },
    SET_BILLING_ADDRESS(state, address) {
        state.billing_address = address;
    },
    SET_LOYALTY(state, loyalty) {
        state.loyalty = loyalty;
        checkout.store(state);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
